





















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class BaseInfoPanelBook extends Vue {
    @Prop({
        default: '',
    })
    public icon: string;
    @Prop({
        default: '',
    })
    public title: string;
    @Prop({
        default: false,
    })
    public havBtn: boolean;
    @Prop({
        default: false,
    })
    public isBtn: boolean;

    public created() {}
    public mounted() {}
}
